module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/symbolsAKQ@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/symbolsAKQ@3x.png
// module id = 721
// module chunks = 0